/* Why a property is off a campaign's list, or why it joined or left it, as
 * the engine wrote it: each reason a label and the property's value, "Type:
 * Mixed use", and a note when the value changed, "was Multifamily, changed
 * by CoStar on Oct 22" (candidacy.why_not and campaign_changes.py, engine
 * migrations 287 and 288). The screen adds no words of its own. Compare with
 * a campaign and the campaign's Changes tab show it. */

export type Reason = { key: string; label: string; value: string; note?: string };

/** The reasons in a row's jsonb, without anything that is not one. */
export function reasonsOf(v: unknown): Reason[] {
  if (!Array.isArray(v)) return [];
  return v.filter((r): r is Reason =>
    Boolean(r) && typeof r === "object" && typeof (r as Reason).label === "string"
    && typeof (r as Reason).value === "string");
}

export function Reasons({ reasons }: { reasons: readonly Reason[] }) {
  if (!reasons.length) return null;
  return (
    <span className="rs">
      {reasons.map((r, i) => (
        <span className="rs-item" key={`${r.key}-${i}`}>
          <span className="chip">{r.label}: {r.value}</span>
          {r.note ? <span className="muted rs-note">{r.note}</span> : null}
        </span>
      ))}
    </span>
  );
}
